import {label} from "@/class/label";

export class text extends label{
    
    objectType = "text";
    parentObjectType = "interactive_image";
    
    data = [
        ...this._default.coords,
        ...this._default.pointer,
        {name:"text", type:String, default:""},
    ]
    
    constructor() {
        super();
        this.init();
    }
    
}